import { GameData } from "../game-data.js";
import ResourceVector from "../resource-vector.js";

export default class FleetFormulas {
    static getFuelForLaunch(fleet) {
        return Math.ceil(fleet.stats.structure / 10);
    }

    static getTimeForLaunch(fleet) {
        if (fleet.ship_count === 0) {
            return 0;
        }

        let time = (GameData.HOUR / fleet.stats.acceleration) / GameData.SPEED;
        time = Math.max(1, time);
        return Math.ceil(time);
    }

    static getFuelForLand(fleet) {
        let fuel = FleetFormulas.getFuelForLaunch(fleet);
        return Math.ceil(fuel / 2);
    }

    static getTimeForLand(fleet) {
        return Math.ceil(FleetFormulas.getTimeForLaunch(fleet) / 2);
    }

    static getTimeForLoadingResources(resources, space_port_level) {
        let helper = new ResourceVector().initSparse(resources);
        let sum = helper.sumUpVector();
        sum = Math.max(60 * GameData.SECOND, sum * GameData.SECOND / (space_port_level + 1));
        sum = sum / GameData.SPEED;
        return Math.ceil(sum);
    }

    static getTimeForMove(fleet, from, to) {
        if (fleet.ship_count === 0) {
            return 0;
        }

        let slowest_acceleration = fleet.stats.acceleration;
        let planet_distance = Math.pow(Math.abs(from.z - to.z), 0.5);
        let ss_distance = Math.pow(Math.pow(from.x - to.x, 2) + Math.pow(from.y - to.y, 2), 0.3);

        if (ss_distance === 0) {
            // Same ss -> only planet travel time
            return Math.ceil((20 * GameData.HOUR * planet_distance) / slowest_acceleration / GameData.SPEED);
        } else {
            // Different ss -> only ss travel time
            return Math.ceil((300 * GameData.HOUR * Math.sqrt(ss_distance)) / slowest_acceleration / GameData.SPEED);
        }
    }

    static getFuelForMove(fleet, from, to) {
        if (fleet.ship_count === 0) {
            return 0;
        }

        let total_thrust = fleet.stats.thrust;
        let planet_distance = Math.pow(Math.abs(from.z - to.z), 0.5);
        let ss_distance = Math.pow(Math.pow(from.x - to.x, 2) + Math.pow(from.y - to.y, 2), 0.3);

        if (ss_distance === 0) {
            // Same ss -> only planet travel time
            return Math.ceil(total_thrust / 23 * planet_distance);
        } else {
            // Different ss -> only ss travel time
            return Math.ceil(total_thrust / 8 * ss_distance);
        }
    }

    static getTimeForColonize(planet) {
        return Math.ceil(10 * GameData.HOUR / GameData.SPEED);
    }

    static getTimeForRaid() {
        return Math.ceil(3 * GameData.HOUR / GameData.SPEED);
    }

    static getTimeForRepair(fleet) {
        return (fleet.stats.sustained_damage / fleet.stats.repair) * GameData.HOUR / GameData.SPEED;
    }
}
